<template>
  <div class="intro-wrapper">
    <nav-common :nav="nav"></nav-common>
    <div class="intro-conent">
      <div class="intro-inner">
        <item-detail v-if="detail.file_url ==false" :detail="detail"></item-detail>
        <file-down v-if="detail.file_url !=false" :detail="detail"></file-down>
      </div>
    </div>
  </div>
</template>
<style scoped>
.intro-conent {
  width: flex;
  background: #e6ecf2;
  padding: 20px 0;
  border: 1px solid #e6ecf2;
  border-radius: 10px;
  box-sizing: border-box;
}
.intro-inner {
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
  background: #fff;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import fileDown from "@/components/views/common/fileDown.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      seconTitle: "",
      detail: {},
      nav: {
        firsttitle: "科研与国际合作",
        firstrouteName: "CooperMajor",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      }
    };
  },
  methods: {
    getDetail() {
      userApi.cooperationDetail({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
      });
    },
    handleRoute() {
      var arr = [
        "重大专项",
        "国际合作",
        "管理规定",
        "科研项目介绍",
        "获奖项目清单",
        "常用文件下载"
      ];
      this.nav.secondtitle = arr[this.$route.query.type * 1 - 1];
    }
  },
  mounted() {
    this.getDetail();
    this.handleRoute();
  },
  watch: {
    $route(val, oldval) {
      this.getDetail();
      this.handleRoute();
    }
  },
  components: {
    navCommon,
    itemDetail,
    fileDown
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Cooperation/Children/detail.vue